import getOperationName from './getOperationName';

export default getOperationName;
